import script from "./RegisterObstacleRace2026.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterObstacleRace2026.vue?vue&type=script&setup=true&lang=js"

import "./RegisterObstacleRace2026.vue?vue&type=style&index=0&id=a64741ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a64741ae"]])

export default __exports__